import { getProp } from '../Utils/formHelpers';

/**
 * Calcola lo stato della Radio in base alle props e allo stato della form eventuale.
 */
export default function useRadioFormChecked({
  stato, name, value, checked,
}) {
  const contesto = stato && name && getProp(name, stato);
  return (stato && name) ? (`${contesto}`) === (`${value}`) || checked || false : checked;
}
